// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import { modalButtonsActionStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

defaultShippingAddressStyles.editLink = {
    css: css`
        font-weight: bold;
        font-size: 12px;
        margin-left: 10px;
        margin-top: 10px;
        white-space: nowrap;
    `,
};

defaultShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "xs")} {
            justify-content: space-between;
        }
    `,
};

defaultShippingAddressStyles.customerSelectorModalCancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

defaultShippingAddressStyles.customerSelectorModalButtonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};
